<script>
import {
  required, email, minLength, maxLength,
} from 'vuelidate/lib/validators';
import { isProd } from '@shared/env';
import { notInTempEmails, /* inArray, */ isValue } from '@shared/config/vuelidate';
import emailList from '@shared/assets/data/temp_emails.json';
import TurnstileWidget from '@app/components/TurnstileWidget.vue';

export default {
  components: { TurnstileWidget },
  data() {
    return {
      user: {
        firstname: '',
        lastname: '',
        token: this.$route.query.t,
        email: this.$route.query.email ? this.$route.query.email.toLowerCase() : '',
        password: '',
        accept_email_marketing: false,
        // plan: this.$route.query.pro ? 'PRO' : 'PERCENT',
      },
      accept: false,
      isLoading: false,
      submitCounter: 0,
    };
  },
  watch: {
    'user.email': function(newValue) {
      if (newValue && !this.$route.query.email) {
        this.user.email = newValue.toLowerCase();
      }
    },
  },
  validations: {
    user: {
      firstname: {
        required,
        maxLength: maxLength(128),
      },
      lastname: {
        required,
        maxLength: maxLength(128),
      },
      email: {
        required,
        email,
        notInTempEmails: notInTempEmails(isProd ? emailList : []),
      },
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(100),
      },
      // plan: {
      //   required,
      //   inArray: inArray(['PRO', 'PERCENT']),
      // },
    },
    accept: {
      isValue: isValue(true),
    },
  },
  methods: {
    handle() {
      this.isLoading = true;
      this.$store.dispatch('auth/register', this.user)
        .then(() => {
          const d = document.createElement('iframe');
          d.style.width = '0';
          d.style.height = '0';
          d.style.border = '0';
          d.style.overflow = 'hidden';
          d.src = `https://www.${this.$env.rootHost}/${(this.$isProd ? 'thank-you-signup' : 'toto')}/`;
          document.body.appendChild(d);
        })
        .catch((error) => {
          this.$errorHandlers.axios(error);
          this.submitCounter += 1;
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<template>
  <section class="form p-5">
    <form novalidate @submit.prevent="dataIsValid(isLoading) && handle()">
      <h1 class="title is-4">
        Inscription
      </h1>

      <div class="columns is-multiline">
        <b-field
          class="column mb-0 pb-0 is-6"
          v-bind="$getErrorProps($v.user.firstname, ['required', { name: 'maxLength', args: [128] }])"
        >
          <template #label>
Prénom <span class="has-text-danger">*</span>
</template>
          <b-input v-model="user.firstname" />
        </b-field>
        <b-field
          class="column mb-0 pb-0 is-6"
          v-bind="$getErrorProps($v.user.lastname, ['required', { name: 'maxLength', args: [128] }])"
        >
          <template #label>
Nom <span class="has-text-danger">*</span>
</template>
          <b-input v-model="user.lastname" />
        </b-field>

        <b-field
          class="column mb-0 pb-0 is-12"
          v-bind="$getErrorProps($v.user.email, ['required', 'email', 'notInTempEmails'])"
        >
          <template #label>
Adresse email <span class="has-text-danger">*</span>
</template>
          <b-input v-model="user.email" type="email" :disabled="$route.query.email" />
        </b-field>

        <b-field
          class="column mb-0 pb-0 is-12"
          v-bind="$getErrorProps($v.user.password, [
            'required',
            { name: 'minLength', args: [8] },
            { name: 'maxLength', args: [100] },
          ])"
        >
          <template #label>
Mot de passe <span class="has-text-danger">*</span>
</template>
          <b-input v-model="user.password" type="password" placeholder="8 caractères minimum" password-reveal />
        </b-field>

        <!-- <b-field
          class="column mb-0 pb-0 is-12"
          v-bind="$getErrorProps($v.user.plan, ['required', 'inArray'])"
        >
          <b-switch v-model="user.plan" type="is-success" size="is-small" true-value="PRO" false-value="PERCENT">
            Prendre le Pack PRO
          </b-switch>
        </b-field> -->

        <div class="column is-12 pb-0">
          <p class="is-size-10 has-text-justified" style="font-size: 0.70rem">
            Teachizy traite vos données personnelles pour créer et gérer votre compte et, en cas de sélection de l'option, pour vous adresser sa lettre d'information. Pour en savoir plus sur la gestion de vos données personnelles et pour exercer vos droits,
            <a class="tdecoration-underline" href="https://maj-digital.notion.site/politique-de-confidentialite" target="_blank" rel="noopener noreferrer">
              cliquez ici.
            </a>
          </p>
        </div>

        <b-field
          class="column mb-0 pb-0 is-12"
          v-bind="$getErrorProps($v.accept, [{ name: 'isValue', message: 'Vous devez accepter nos conditions' }])"
        >
          <b-checkbox v-model="accept" size="is-small">
            J'accepte les
            <a class="tdecoration-underline" href="https://maj-digital.notion.site/cgv" target="_blank" rel="noopener noreferrer">
              conditions générales de vente
            </a>
            et la
            <a class="tdecoration-underline" href="https://maj-digital.notion.site/politique-de-confidentialite" target="_blank" rel="noopener noreferrer">
              politique de confidentialité
            </a>
            de Teachizy. <span class="has-text-danger">*</span>
          </b-checkbox>
        </b-field>
        <div class="column">
          <div class="px-10 py-5 my-3 is-12 -mx-10 has-background-primary-light">
            <b-checkbox class="is-primary" v-model="user.accept_email_marketing" size="is-small">
              <strong>📩 La Lettre Teachizy</strong>
              <br>
              Recevoir tous les mois un concentré d'astuces, d'outils et d'actus pour mieux former en ligne !
            </b-checkbox>
          </div>
        </div>

        <div
          class="column m-0 p-0 is-12 is-flex is-flex-direction-column is-justify-content-center is-align-items-center"
        >
          <TurnstileWidget :counter="submitCounter" @validated="(value) => (user.turnstile_token = value)" />
        </div>

        <b-field class="column mb-0 pb-0 is-12">
          <b-button type="is-primary" native-type="submit" :loading="isLoading" expanded>
            S'inscrire
          </b-button>
        </b-field>

        <div class="column is-12 pt-1 mt-3">
          <p class="is-size-12" style="font-size: 0.70rem">
            Les champs marqués d'un <span class="has-text-danger">*</span> sont requis pour créer votre compte.
          </p>
        </div>
      </div>
    </form>

    <hr>

    <p>
      Déjà un compte ?
      <router-link class="tdecoration-underline" to="/connexion">
        Connectez-vous
      </router-link>
    </p>
  </section>
</template>
